var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.25C14.25 5.317 12.683 3.75 10.75 3.75C8.817 3.75 7.25 5.317 7.25 7.25C7.25 9.183 8.817 10.75 10.75 10.75C12.683 10.75 14.25 9.183 14.25 7.25Z",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.233 7.59987C14.555 7.6975 14.8965 7.75 15.2503 7.75C17.1833 7.75 18.7503 6.183 18.7503 4.25C18.7503 2.317 17.1833 0.75 15.2503 0.75C13.4354 0.75 11.9431 2.1314 11.7676 3.90013",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73273 3.90013C9.55719 2.1314 8.06492 0.75 6.25 0.75C4.317 0.75 2.75 2.317 2.75 4.25C2.75 6.183 4.317 7.75 6.25 7.75C6.60381 7.75 6.94535 7.6975 7.26727 7.59987",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 12.75C20.75 9.98858 18.2876 7.75 15.25 7.75",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15.75C16.25 12.9886 13.7876 10.75 10.75 10.75C7.71243 10.75 5.25 12.9886 5.25 15.75",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.75C3.21243 7.75 0.75 9.98858 0.75 12.75",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.2053bf8623ba39f0107e269e0e17422c.svg";
export { ForwardRef as ReactComponent };